// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"557d8d1d","453":"5a0124cd","593":"1df8655e"}[chunkId] + ".chunk.js";
};